module.exports = __webpack_public_path__ + "static/media/feelingProud.7b299f5c.png";